<template>
  <div class="btn-menu-tongle">
    <v-menu>
      <template v-slot:activator="{ props }">
        <v-btn icon="mdi-dots-vertical" variant="text" v-bind="props">
          <label class="menu-icon" for="menu-toggle"> &#9776; </label>
        </v-btn>
      </template>
      <v-list class="bg-black">
        <v-list-item>
          <v-list-item-title class="v-list-item-title">
            <v-btn
              class="bg-black btn-menu"
              @click="$router.push({ name: 'CountView' })"
            >
              {{ userInfo.name + " " + userInfo.surNames }}
            </v-btn>
          </v-list-item-title>
          <v-list-item-title class="v-list-item-title">
            <v-btn
              class="bg-black btn-menu"
              @click="$router.push({ name: 'myCompanysView' })"
            >
              Mis empresas
            </v-btn>
          </v-list-item-title>
         
          <v-list-item-title class="v-list-item-title">
            <v-btn
              class="bg-black btn-menu"
              @click="$router.push({ name: 'MyPaymentsView' })"
            >
              Mis pagos
            </v-btn>
          </v-list-item-title>
          <v-list-item-title class="v-list-item-title" v-if="userInfo?.role === 'administrador'">
            <v-btn 
              class="bg-black btn-menu"
              @click="$router.push({ name: 'AllCompanysView' })">
              Todas las empresas
            </v-btn>
          </v-list-item-title>
          <v-list-item-title class="v-list-item-title" v-if="userInfo.role === 'administrador'">
            <v-btn
              class="bg-black btn-menu"
              @click="$router.push({ name: 'UsersView' })"
            >
              Usuarios
            </v-btn>
          </v-list-item-title>
          <v-list-item-title class="v-list-item-title" v-if="userInfo.role === 'administrador'">
            <v-btn
              class="bg-black btn-menu"
              @click="$router.push({ name: 'AdminSitesView' })"
            >
              Administrar lugares
            </v-btn>
          </v-list-item-title>
          <v-list-item-title class="v-list-item-title" v-if="userInfo.role === 'administrador'">
            <v-btn
              class="bg-black btn-menu"
              @click="$router.push({ name: 'AccessDashboardView' })"
            >
              Estadísticas
            </v-btn>
          </v-list-item-title>
          <v-list-item-title class="v-list-item-title" v-if="userInfo.role === 'administrador'">
            <v-btn
              class="bg-black btn-menu"
              @click="$router.push({ name: 'AdminSettingsView' })"
            >
              Configuración
            </v-btn>
          </v-list-item-title>
          <v-list-item-title class="v-list-item-title">
            <v-btn class="bg-black btn-menu" @click="logout()">
              Cerrar sesión
            </v-btn>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
  <v-menu offset-y class="menu-usuario">
    <template v-slot:activator="{ props }">
      <v-btn class="btn-menu-user" color="primary" v-bind="props">
        <v-icon>mdi-account-circle</v-icon>
        {{ userInfo.name + " " + userInfo.surNames }}
      </v-btn>
    </template>
    <v-list class="bg-blue f g-white" >
      <v-list-item width="100%" style="justify-items: start" @click="$router.push({ name: 'CountView' })">
        <v-btn
          class="bg-blue fg-white"
          width="100%"
          style="justify-content: left"
        >
          <v-icon class="mx-2"> mdi-account-circle </v-icon>
          {{ userInfo.name + " " + userInfo.surNames }}
        </v-btn>
      </v-list-item>
      <v-list-item width="100%" @click="$router.push({ name: 'myCompanysView' })">
        <v-btn
          class="bg-blue fg-white"
          width="100%"
          style="justify-content: left"
        >
          <v-icon class="mx-2"> mdi-domain </v-icon>
          Mis empresas
        </v-btn>
      </v-list-item>
      <v-list-item width="100%" @click="$router.push({ name: 'MyPaymentsView' })">
        <v-btn
          class="bg-blue fg-white"
          width="100%"
          style="justify-content: left"
        >
          <v-icon class="mx-2"> mdi-cash-multiple </v-icon>
          Mis pagos
        </v-btn>
      </v-list-item>

      <v-list-item v-if="userInfo?.role === 'administrador'" width="100%" @click="$router.push({ name: 'AllCompanysView' })">
        <v-btn
          class="bg-blue fg-white"
          width="100%"
          style="justify-content: left"
        >
          <v-icon class="mx-2">mdi-office-building</v-icon> Todas las empresas
        </v-btn>
      </v-list-item>

      <v-list-item v-if="userInfo.role === 'administrador'" width="100%" @click="$router.push({ name: 'UsersView' })">
        <v-btn
          class="bg-blue fg-white"
          width="100%"
          style="justify-content: left"
        >
          <v-icon class="mx-2">mdi-account-group</v-icon>
          Usuarios
        </v-btn>
      </v-list-item>
      <v-list-item v-if="userInfo.role === 'administrador'" width="100%" @click="$router.push({ name: 'AdminSitesView' })">
        <v-btn
          class="bg-blue fg-white"
          width="100%"
          style="justify-content: left"
        >
          <v-icon class="mx-2">mdi-map-marker-multiple</v-icon>
          Administrar lugares
        </v-btn>
      </v-list-item>
      <v-list-item v-if="userInfo.role === 'administrador'" width="100%" @click="$router.push({ name: 'AccessDashboardView' })">
        <v-btn
          class="bg-blue fg-white"
          width="100%"
          style="justify-content: left"
        >
          <v-icon class="mx-2">mdi-chart-box-outline</v-icon>
          Estadísticas
        </v-btn>
      </v-list-item>
      <v-list-item v-if="userInfo.role === 'administrador'" width="100%" @click="$router.push({ name: 'AdminSettingsView' })">
        <v-btn
          class="bg-blue fg-white"
          width="100%"
          style="justify-content: left"
        >
          <v-icon class="mx-2">mdi-tune-variant</v-icon>
          Configuración
        </v-btn>
      </v-list-item>
      <v-list-item width="100%" @click="logout()">
        <v-btn
          class="bg-blue fg-white"
          width="100%"
          style="justify-content: left"
        >
          <v-icon class="mx-2">mdi-logout</v-icon>
          Cerrar sesión
        </v-btn>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
import apisUser from "@/apis/apisUsers";

export default {
  name: "ComponentMenuUser",
  props: {
    userInfo: {
      type: Object,
      required: true,
    },
  },
  methods: {
    logout() {
      apisUser.logout().then((logout) => {
        this.isValid = !logout;
        this.$router.push("/");
      });
    },
  },
};


</script>
<style scoped>
/* Estilos para que el botón de usuario se vea bien en el Header */
.btn-menu-user {
  font-weight: 500;
  border-radius: 10px;
  text-transform: none;
  box-shadow: 0 2px 6px rgba(25, 118, 210, 0.4);
}

.btn-menu-tongle {
  display: none; /* Se oculta en desktop */
}

.menu-icon {
  font-size: 28px;
  cursor: pointer;
  color: #fff;
}

.btn-menu {
  width: 100%;
  justify-content: flex-start;
  text-transform: none;
}

.menu-list-container :deep(.v-list-item) {
  cursor: pointer;
  padding: 10px 15px;
}

.menu-list-container :deep(.v-list-item:hover) {
  background-color: rgba(255, 255, 255, 0.1);
}

.fg-white {
  color: white !important;
}

/* RESPONSIVE: Mostrar hamburguesa, ocultar botón de nombre */
@media screen and (max-width: 600px) {
  .btn-menu-user {
    display: none !important;
  }

  .btn-menu-tongle {
    display: flex !important;
    justify-content: flex-end;
  }
}
</style>